import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  meta: "BLOGS",
};

export const getAllBlogs = createAsyncThunk(
  "Blogs/getAllBlogs",
  async (payload) => {
    try {
      const response = await api.blogs.getAllBlogs(payload);
      if (response.status === 200) return response.data;
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getBlogById = createAsyncThunk(
  "Blogs/getBlogById",
  async (id) => {
    try {
      const response = await api.blogs.getBlogById(id);
      if (response.status === 200) return response.data;
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createBlogs = createAsyncThunk(
  "Blogs/createBlogs",
  async (payload) => {
    try {
      const response = await api.blogs.createBlogs(payload);
      if (response.status === 201) return response.data;
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateBlogs = createAsyncThunk(
  "Blogs/updateBlogs",
  async ({ id, payload }) => {
    try {
      const response = await api.blogs.updateBlogs(id, payload);
      if (response.status === 200) return response.data;
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const deleteBlogs = createAsyncThunk(
  "Blogs/deleteBlogs",
  async ({ id }) => {
    try {
      const response = await api.blogs.deleteBlogs(id);
      if (response.status === 200) return response.data;
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export const {} = blogsSlice.actions;
export default blogsSlice.reducer;
